export const FACULTY_ASSESSMENTS_PATH = '/faculty/assessments';
export const FACULTY_ASSESSMENT_NEW_PATH = '/faculty/assessments/new';

/** Poll interval for GET /monitor — matches platform MONITOR_CACHE_TTL_MS (AO-1.16). */
export const ASSESSMENT_MONITOR_POLL_MS = 10_000;

/** Poll interval for GET /integrity-dashboard — matches dashboard cache TTL (AO-4.4). */
export const ASSESSMENT_INTEGRITY_DASHBOARD_POLL_MS = 10_000;

/** @param {string} id */
export function facultyAssessmentEditPath(id) {
  return `/faculty/assessments/${id}/edit`;
}

/** @param {string} id */
export function facultyAssessmentPath(id) {
  return `/faculty/assessments/${id}`;
}

/** @param {string} id */
export function facultyAssessmentMonitorPath(id) {
  return `/faculty/assessments/${id}/monitor`;
}

/** AMI-6.2 — review queue (only AMI-added faculty route). */
export function facultyAssessmentReviewPath(id) {
  return `/faculty/assessments/${id}/review`;
}

/** @param {string} id */
export function facultyAssessmentIntegrityDashboardPath(id) {
  return `/faculty/assessments/${id}/integrity-dashboard`;
}

/** @param {string} assessmentId @param {string} attemptId */
export function facultyAttemptDetailPath(assessmentId, attemptId) {
  return `/faculty/assessments/${assessmentId}/attempts/${attemptId}`;
}

/** @param {string} assessmentId @param {string} attemptId */
export function facultyAttemptIntegrityReportPath(assessmentId, attemptId) {
  return `/faculty/assessments/${assessmentId}/attempts/${attemptId}/integrity-report`;
}

/** @param {string} id */
export function facultyAssessmentSummaryPath(id) {
  return `/faculty/assessments/${id}/summary`;
}

/** Statuses where the live console is useful (materialised cohort exists). */
export const ASSESSMENT_MONITORABLE_STATUSES = Object.freeze([
  'published',
  'open',
  'closed',
  'reconciling',
  'finalised',
]);

export const ASSESSMENT_STATUS_TABS = Object.freeze([
  { key: 'all', label: 'All Active', status: undefined },
  { key: 'draft', label: 'Draft', status: 'draft' },
  { key: 'scheduled', label: 'Scheduled', status: 'published' },
  { key: 'live', label: 'Live', status: 'open' },
  { key: 'completed', label: 'Completed', status: 'finalised' },
  { key: 'archived', label: 'Archived', status: 'archived' },
]);

/**
 * Tabs on the assessment detail page (results-first refresh).
 *
 * Results leads because a mark is what faculty come for; monitoring keeps every
 * capability it had, one tab across. Order is deliberate: outcome, then the
 * questions behind it, then the integrity review, then the live console.
 */
export const ASSESSMENT_DETAIL_TABS = Object.freeze([
  { key: 'results', label: 'Results' },
  { key: 'questions', label: 'Questions' },
  { key: 'integrity', label: 'Integrity' },
  { key: 'monitoring', label: 'Monitoring' },
]);

export const ASSESSMENT_DEFAULT_TAB = 'results';

/** Statuses where marks exist and a gradebook is worth opening. */
export const ASSESSMENT_RESULT_BEARING_STATUSES = Object.freeze([
  'open',
  'closed',
  'reconciling',
  'finalised',
  'archived',
]);

/** @param {string} id @param {string} [tab] */
export function facultyAssessmentDetailPath(id, tab) {
  const base = `/faculty/assessments/${id}`;
  return tab && tab !== ASSESSMENT_DEFAULT_TAB ? `${base}?tab=${tab}` : base;
}
